import { WidgetFrameAdapter } from "./WidgetFrameAdapter";
import { WidgetModelPinPreference } from "./WidgetModelPinPreference";
import { WidgetModelRegistration } from "./WidgetModelRegistration";
export class WidgetModelApi {
    constructor(orchestratorFactory) {
        this._orchestratorFactory = orchestratorFactory;
        this._eventListeners = new Array();
        this._registrationEventListeners = new Array();
    }
    // Inform WebXT that this widget has been removed
    removeWidget(widgetId, instanceId) {
        for (let index = 0; index < this._eventListeners.length; index++) {
            if (this._eventListeners[index]) {
                this._eventListeners[index]("widgetRemoved", [widgetId, instanceId, "", ""]);
            }
        }
    }
    // Called by WebXT to obtain the list of widget definition Ids that exist.
    // TODO: http://task.ms/40366288 We need a new model where we ask for a number of slots and their render callback requests
    async getWidgetRegistrations() {
        let orch = await this._orchestratorFactory.getWidgetOrchestrator();
        let widgetModelRegistrations = (await orch.getWidgetRegistrations()).map((r) => {
            return new WidgetModelRegistration(r);
        });
        return widgetModelRegistrations;
    }
    async getWidgetRegistration(id) {
        let orch = await this._orchestratorFactory.getWidgetOrchestrator();
        let widgetRegistration = (await orch.getWidgetRegistrations()).find((r) => r.id === id);
        return widgetRegistration ? new WidgetModelRegistration(widgetRegistration) : undefined;
    }
    async getUserPinnedPreferences() {
        let orch = await this._orchestratorFactory.getWidgetOrchestrator();
        return orch.getWidgetInstances().then((instances) => {
            return instances.map((i) => {
                return new WidgetModelPinPreference(i);
            });
        });
    }
    // called by dynamic feed when it has pinned a card/widget
    async createPinPreference(id, instanceId) {
        let orch = await this._orchestratorFactory.getWidgetOrchestrator();
        let registrations = await orch.getWidgetRegistrations();
        let widgetRegistration = registrations.find((r) => {
            return r.id === id;
        });
        if (widgetRegistration) {
            return orch.addWidgetInstance(widgetRegistration, undefined);
        }
        else {
            throw new Error("Registration not found for " + id);
        }
    }
    // called by dynamic feed when it has unpinned a card/widget
    async removePinPreference(id, instanceId) {
        let orch = await this._orchestratorFactory.getWidgetOrchestrator();
        // Only match widget id as WebxT is not setting the InstanceId reliably.
        let widgetInstance = (await orch.getWidgetInstances()).find((i) => {
            return i.widgetId === id;
        });
        if (widgetInstance) {
            orch.removeWidgetInstance(widgetInstance);
        }
        else {
            throw new Error("Instance not found for id: " + id);
        }
    }
    async setPinnedWidgetSize(id, instanceId, size) {
        const orch = await this._orchestratorFactory.getWidgetOrchestrator();
        const widgetInstance = (await orch.getWidgetInstances()).find((i) => {
            return i.widgetId === id;
        });
        if (widgetInstance) {
            const sizeApi = widgetInstance.tryGetApi("sizes", 1, 1);
            if (sizeApi) {
                sizeApi.fireStartEvent(size);
                sizeApi.fireEndEventAndUpdateSize(size);
            }
            else {
                throw new Error("Size API couldn't be retrieved for id: " + id + " instanceId: " + instanceId);
            }
        }
        else {
            throw new Error("Instance not found for id: " + id + " instanceId: " + instanceId);
        }
    }
    // Call when the widget enters or exits the viewport.
    async onVisibleStateChanged(id, instanceId, isVisible) {
        const orch = await this._orchestratorFactory.getWidgetOrchestrator();
        const widgetInstance = (await orch.getWidgetInstances()).find((i) => {
            return i.widgetId === id;
        });
        if (widgetInstance) {
            await new WidgetFrameAdapter(widgetInstance).onVisibleStateChanged(isVisible);
        }
        else {
            throw new Error("onWidgetIsVisible - Widget did not exist: " + id + " instanceId: " + instanceId);
        }
    }
    addEventListener(listener) {
        if (this._eventListeners.length === 0) {
            this._orchestratorFactory.getWidgetOrchestrator().then((orch) => {
                orch.addEventListener((e, w) => this.orchestratorEventListener(e, w));
            });
        }
        this._eventListeners.push(listener);
    }
    removeEventListener(listener) {
        let index = this._eventListeners.indexOf(listener);
        if (index > -1) {
            this._eventListeners.splice(index, 1);
        }
        if (this._eventListeners.length === 0) {
            this._orchestratorFactory.getWidgetOrchestrator().then((orch) => {
                orch.removeEventListener((e, w) => this.orchestratorEventListener(e, w));
            });
        }
    }
    orchestratorEventListener(eventName, widgetInstance) {
        for (let index = 0; index < this._eventListeners.length; index++) {
            if (this._eventListeners[index] && widgetInstance) {
                this._eventListeners[index](eventName, [
                    widgetInstance.widgetId,
                    widgetInstance.instanceId,
                    widgetInstance.widgetDefinitionId,
                    widgetInstance.widgetRegistration.preferredSize,
                ]);
            }
        }
    }
    registrationsAdded(registrations) {
        this.registrationEvent("added", registrations);
    }
    registrationsRemoved(registrations) {
        this.registrationEvent("removed", registrations);
    }
    registrationsChanged(registrations) {
        this.registrationEvent("changed", registrations);
    }
    registrationEvent(eventName, registrations) {
        for (let index = 0; index < this._registrationEventListeners.length; index++) {
            this._registrationEventListeners[index](eventName, registrations);
        }
    }
    addRegistrationListener(listener) {
        this._registrationEventListeners.push(listener);
    }
    removeRegistrationListener(listener) {
        let index = this._registrationEventListeners.indexOf(listener);
        if (index > -1) {
            this._registrationEventListeners.splice(index, 1);
        }
    }
}
